import { createTheme } from '@one-thd/sui-atomic-components';

const Halloween2026PrimaryOne = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand'
    }
  }
});

Halloween2026PrimaryOne.palette['--sui-palette-background-primary'] = '117 67 108';

export { Halloween2026PrimaryOne };